

export function afterDomUpdate(func) {
   requestAnimationFrame(() =>
      requestAnimationFrame(() => {
         func();
      }
   ));
}

export function minutesToTime(minutes) {
   return ('00' + Math.floor(minutes / 60)).slice(-2) + ':' + ('00' + minutes % 60).slice(-2);
}

export function objectMap(obj, fn) {
  return Object.fromEntries(
    Object.entries(obj).map(
      ([k, v], i) => [k, fn(v, k, i)]
    )
  )
}

export function keysExist(object, keys) {

   let o = object;
   for (let key of keys) {
      if (key in o == false) return false;
      o = o[key];
   }

   return true;

}

export function groupClassNames(classes) {

   let groupable = true;
   let year = null;
   let list = [];

   for (const cls of classes) {
      if (cls.name !== cls.year + cls.ext) groupable = false;
      if (year !== null && year !== cls.year)  groupable = false;
      list.push(cls);
      year = cls.year;
   }

   if (!groupable) return list.map(cls => { return cls.name; }).join(',');
   // implode(',', array_map(function($class) { return $class->name; }, $list));
   else {
      list.sort((a,b) => { return a.name.localeCompare(b.name); });
      return list.reduce((result, cls) => { return result + cls.ext; }, '' + year);
   }

}

export function newId() {

   let id = Math.random().toString(36).substr(2, 9);
   while (document.getElementById(id) !== null) {
      id = Math.random().toString(36).substr(2, 9);
   }
   return id;

}

export function getObjectFromPath(obj, pathString) {

   let path = pathString.split(/(\.|\[\d+\])/);

   let target = obj;
   for (let i=1; i<path.length; i+=2) {
      if (path[i] === '.') target = target[path[i+1]];
      else target = target[parseInt(path[i].slice(1,-1))];
      if (target === undefined) {
         console.error(path[i+1]);
      }
   
   }


   return target;
   
}

export function sortObjectArray(array, sortKeys) {

   array.sort((a, b) => {
      for (let key of sortKeys) {
         const sortDir = key[0] === '<' ? 1 : -1;
         let keyA = getObjectFromPath(a, key);
         let keyB = getObjectFromPath(b, key);
         if (keyA > keyB) return sortDir;
         if (keyA < keyB) return -sortDir;
      }
      return 0;
   });

}

export function isObject(objValue) {
   return objValue && typeof objValue === 'object' && objValue.constructor === Object;
}

export function createRandomId(len) {
   const dec2hex = function(dec) { return dec.toString(16).padStart(2, "0"); }
   var arr = new Uint8Array((len || 20) / 2)
   window.crypto.getRandomValues(arr)
   return Array.from(arr, dec2hex).join('')
}

export function groupData(data, groupBy, initFunction, aggregateFunction) {

   const isSameGroup = (group, item) => {
      for (let key of groupBy) {
         if (group[key] !== item[key]) return false;
      }
      return true;
   }

   sortObjectArray(data, groupBy.map(item => '<.' + item));

   let groups = [];
   let group = false;
   for (let item of data) {
      if (group === false || !isSameGroup(group, item)) {
         if (group !== false) groups.push(group);
         group = {};
         for (let key of groupBy) group[key] = item[key];
         initFunction(group);
      }
      aggregateFunction(group, item);
   }

   if (group !== false) {
      groups.push(group);
   }

   return groups;

}

export function formatLink(text) {
   
   return text.replace(
      ///[(.*)@(http(s):\/\/.)[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*))]/,
      /\[(.*)@((https?:\/\/.)[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=;]*))\]/,
      `<a href="$2" class="auto-link" target="_blank">$1</a>`
   );

}

export function sortTeacherByShort(a, b) {
   if (a.short < b.short) return -1;
   if (a.short > b.short) return  1;
   return 0;
}

export function sortPupilByClassAndName(a, b) {
   if (!a.class || !b.class) return 0;
   if (a.class.year < b.class.year) return -1;
   if (a.class.year > b.class.year) return  1;
   if (a.class.ext < b.class.ext) return -1;
   if (a.class.ext > b.class.ext) return  1;
   if (a.normedLastName < b.normedLastName) return -1;
   if (a.normedLastName > b.normedLastName) return  1;
   if (a.normedFirstName < b.normedFirstName) return -1;
   if (a.normedFirstName > b.normedFirstName) return  1;
   return 0;
}

export function sortClass(a, b) {
   if (a.year < b.year) return -1;
   if (a.year > b.year) return  1;
   if (a.ext < b.ext) return -1;
   if (a.ext > b.ext) return  1;
   return 0;
}

export function sortRoom(a, b) {
   if (a.short < b.short) return -1;
   if (a.short > b.short) return  1;
   return 0;
}